(function () {
  function sortHeaderWorkshopCards() {
    const utils = window.WorkshopDateUtils;
    if (!utils) return;

    const cards = Array.from(document.querySelectorAll('[data-header-workshop-card]'));
    if (!cards.length) return;
    const now = new Date();

    const listMap = new Map();
    cards.forEach((card) => {
      const slide = card.classList.contains('splide__slide')
        ? card
        : card.closest('.splide__slide');
      const list = card.closest('.splide__list') || card.parentElement;
      if (!slide || !list) return;
      if (!listMap.has(list)) listMap.set(list, []);
      listMap.get(list).push({ card, slide });
    });

    listMap.forEach((items, list) => {
      items.sort((a, b) => utils.compareWorkshopItems(a.card, b.card, 1, now));
      items.forEach((item) => list.appendChild(item.slide));
    });
  }

  /** Find a Workshop → All panel: same session order (earliest next → waitlist/no date last). */
  function sortHeaderAllPanel() {
    const grids = document.querySelectorAll(
      '[data-amc-find-panel="0"] .amc-find-mega__grid, .amc-mn-find__workshops'
    );
    grids.forEach((grid) => {
      const items = Array.from(grid.children).filter((el) => {
        return (
          el.classList.contains('amc-mega-product-card') ||
          el.classList.contains('card-product') ||
          el.matches('li')
        );
      });
      if (items.length < 2) return;

      items.sort((a, b) => {
        const aKey = String(a.getAttribute('data-amc-next') || '').trim();
        const bKey = String(b.getAttribute('data-amc-next') || '').trim();
        if (!aKey && !bKey) return 0;
        if (!aKey) return 1;
        if (!bKey) return -1;
        const aDate = aKey.split('~')[0] || '9999-12-31';
        const bDate = bKey.split('~')[0] || '9999-12-31';
        const aWait = aDate >= '9999-01-01';
        const bWait = bDate >= '9999-01-01';
        if (aWait !== bWait) return aWait ? 1 : -1;
        if (aDate !== bDate) return aDate < bDate ? -1 : 1;
        const aTitle = String(
          a.querySelector('.x-card-title, .amc-mn-find__workshop')?.textContent || ''
        )
          .trim()
          .toLowerCase();
        const bTitle = String(
          b.querySelector('.x-card-title, .amc-mn-find__workshop')?.textContent || ''
        )
          .trim()
          .toLowerCase();
        return aTitle.localeCompare(bTitle, undefined, { sensitivity: 'base' });
      });

      items.forEach((el) => grid.appendChild(el));
    });
  }

  function init() {
    sortHeaderWorkshopCards();
    sortHeaderAllPanel();
    setTimeout(function () {
      sortHeaderWorkshopCards();
      sortHeaderAllPanel();
    }, 300);
    setTimeout(function () {
      sortHeaderWorkshopCards();
      sortHeaderAllPanel();
    }, 1000);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
  document.addEventListener('shopify:section:load', init);
})();
